import "element-ui/lib/theme-chalk/index.css";
import "./assets/style/style.css";
import Vue from 'vue';
import App from './App';
import router from './router';
import store from './store/index.js';
import Element from 'element-ui';
import Popup from './components/popup/popup.vue';
import VDistpicker from 'v-distpicker';
import Print from 'vue-print-nb';
import NetworkError from './components/network_error/network_error.vue';
import ImgCutter from 'vue-img-cutter';
import Editor from './components/editor/editor.vue';
import Clipboard from 'clipboard';

Vue.config.productionTip = false;
Vue.use(Element, {
	size: 'medium',
	zIndex: 3000
});
Vue.use(Print);
// 1
Vue.prototype.positiveReg = /^([0-9]|[1-9]\d+)$/;
Vue.prototype.floatReg = /^\d+(\.\d+)?$/;
Vue.prototype.lngReg = /^(-|\+)?(((\d|[1-9]\d|1[0-7]\d|0{1,3})\.\d{0,6})|(\d|[1-9]\d|1[0-7]\d|0{1,3})|180\.0{0,6}|180)$/;
Vue.prototype.latReg = /^(-|\+)?([0-8]?\d{1}\.\d{0,6}|90\.0{0,6}|[0-8]?\d{1}|90)$/;
Vue.prototype.phoneReg = /^1[3456789]\d{9}$/;
Vue.prototype.verCodeReg = /^\d{4,6}$/;
Vue.prototype.passwordReg = /^[^\s]{6,18}$/;
Vue.prototype.nameReg = /^[\u4E00-\u9FA5]{2,4}$/;
Vue.prototype.ageReg = /^(?:[1-9][0-9]?|1[01][0-9]|120)$/;
Vue.prototype.emailReg = /^\w{3,}(\.\w+)*@[A-z0-9]+(\.[A-z]{2,5}){1,2}$/;
Vue.prototype.visionReg = /^[0-5]{1}(\.[0-9]{1,2})?([+-])?$/;
Vue.prototype.documentReg = /^[0-5]{1}\.[0-9]{1,2}?$/;
Vue.prototype.urlReg = /^(https|http):\/\//;
Vue.prototype.Clipboard = Clipboard;
Vue.component("Popup", Popup);
Vue.component('VDistpicker', VDistpicker);
Vue.component('NetworkError', NetworkError);
Vue.component('ImgCutter', ImgCutter);
Vue.component('Editor', Editor);

/* eslint-disable no-new */
new Vue({
	router,
	store,
	render: h => h(App)
}).$mount("#app")
